import { render, staticRenderFns } from "./Stock-minimo.vue?vue&type=template&id=065b074e"
import script from "./Stock-minimo.vue?vue&type=script&lang=js"
export * from "./Stock-minimo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports